import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'

class FlywheelFailed extends React.Component {
	render() {
		const { migrate } = this.props
		const migrationError = migrate.getIn(['errors', 'message'])
		return <div className="fw d-flex">
			<div className="container">
				<div className="jumbotron">
					<img className="checkmark-circle" src="/assets/exclamation_circle.svg" alt=""/>
					<h1 className="fw-600">Migration Failed</h1>
					<p>
						<a href={migrate.get('source_site')} target="_blank" className="font16">{migrate.get('source_site')}</a>
						<img className="arrow-icon" src="/assets/arrow_right.svg" alt=""/>
						<a href={migrate.get('destination_site')} target="_blank" className="font16">{migrate.get('destination_site')}</a>
					</p>
				</div>
				<hr/>
				<div className="center-block bv-error">
					{ migrationError }
				</div>
				<div className="subsection">
					<p className="text-center font13">We want to help! Drop us a line via a support ticket and we&apos;ll get to work.</p>
				</div>
				<div className="jumbotron">
					<a className="button big-green-button" href="https://app.getflywheel.com/tickets/new?source=blogvault" target="_blank">Open a Ticket</a>
				</div>
			</div>
		</div>	
	}         
}           

FlywheelFailed.propTypes = {
	migrate: ImmutablePropTypes.map
}

export default FlywheelFailed
